import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import type {
  TPostPartnerUBODocumentParams,
  TPostPartnerUBODocumentResponse,
} from "./postPartnerUBODocument.schema";

export const postPartnerUBODocument = (axios: IAxiosInstance) => {
  return async (
    params: TPostPartnerUBODocumentParams
  ): Promise<TPostPartnerUBODocumentResponse> => {
    const { whiteLabelID, ubo_document, first_name, last_name } = params;
    const formData = new FormData();
    formData.append("ubo_document", ubo_document);
    formData.append("first_name", first_name);
    formData.append("last_name", last_name);
    const response = await axios.noRetry.post<
      IApiResponse<TPostPartnerUBODocumentResponse>
    >(`/api/partners/${whiteLabelID}/ubo-document`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    const resData = response.data;
    if (resData?.data?.success) {
      return {
        success: true,
        message: resData.data?.message,
      };
    }
    throw new Error("Something went wrong");
  };
};
